/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-controls-skip-back': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.875 17.5a.625.625 0 01-.313-.081L4.688 10.544a.625.625 0 010-1.088l11.875-6.875a.625.625 0 01.938.544v13.75c0 .345-.28.625-.625.625zM6.25 10l10 5.794V4.206L6.25 10zm-5-7.5H2.5v15H1.25v-15z"/>'
  }
})
